export const Jetpur = {
    title: "Jetpur",
    title1: "(Textile & Handloom Hub)",

    intro: "Jetpur, located in the Rajkot district of Gujarat, is renowned for its vibrant textile industry and handloom weaving. Known as the 'Textile City', it has a rich history of producing high-quality fabrics and is home to several textile mills and weavers.",

    attractions: [
        {
            name: "Jetpur Textile Market",
            description: "Jetpur is famous for its textile market, where various fabrics like cotton, silk, and woolen textiles are sold. The market is a major hub for fabric wholesalers, retailers, and manufacturers. It's the perfect place to buy colorful and traditional Gujarati textiles.",
            location: "Jetpur, Gujarat",
            timings: "9:00 AM to 7:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Shop for traditional Gujarati fabrics",
                "Explore different types of textiles like block prints and tie-dye",
                "Interact with local textile vendors",
                "Get customized clothing made by local tailors",
                "Discover unique and colorful textiles"
            ],
            mapLink: "https://maps.app.goo.gl/XHV6M2Ddzyq6nV9W6",
        },
        {
            name: "Hingolgadh Wildlife Sanctuary",
            description: "Located near Jetpur, the Hingolgadh Wildlife Sanctuary is known for its natural beauty and wildlife. The sanctuary is home to various species of birds and animals, making it a great spot for nature lovers and wildlife enthusiasts.",
            location: "Hingolgadh, near Jetpur, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹50 per person",
            bestTimeToVisit: "October to March",
            activities: [
                "Go on a wildlife safari",
                "Birdwatching and nature walks",
                "Spot wildlife like leopards, jackals, and deer",
                "Explore the sanctuary’s diverse flora and fauna",
                "Picnic in the serene surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/B7w1v5f6aH2NG9dZA",
        },
        {
            name: "Shree Swaminarayan Mandir",
            description: "This temple is a significant religious site in Jetpur, dedicated to Lord Swaminarayan. Known for its serene atmosphere and beautiful architecture, it attracts devotees from all over Gujarat.",
            location: "Jetpur, Gujarat",
            timings: "6:00 AM to 12:00 PM & 4:00 PM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend daily aarti and prayers",
                "Admire the temple’s architectural beauty",
                "Participate in religious events and festivals",
                "Meditate in the temple’s peaceful environment",
                "Visit the temple's surrounding gardens"
            ],
            mapLink: "https://maps.app.goo.gl/DXqkK7fZL2dP5YPw8",
        },
        {
            name: "Rukmavati River",
            description: "The Rukmavati River flows through Jetpur, offering a tranquil environment for picnics and nature walks. The river is surrounded by lush greenery and serves as an ideal spot for relaxation and photography.",
            location: "Jetpur, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Late Afternoon",
            activities: [
                "Relax by the riverbanks",
                "Photography of the scenic landscape",
                "Enjoy a picnic with friends and family",
                "Take a boat ride on the river",
                "Take part in local cultural festivities by the river"
            ],
            mapLink: "https://maps.app.goo.gl/TqNTu6bH4KjFZB6y7",
        },
        {
            name: "Jetpur Mahadev Temple",
            description: "This ancient temple is dedicated to Lord Shiva and is one of the most revered places in Jetpur. It is known for its historical significance and serene ambiance.",
            location: "Jetpur, Gujarat",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Attend the evening aarti",
                "Meditate in the peaceful surroundings",
                "Admire the intricate carvings on the temple",
                "Learn about the temple’s history",
                "Engage in religious rituals"
            ],
            mapLink: "https://maps.app.goo.gl/1JfWxD6ZaB8gcmuT6",
        },
        {
            name: "Vishal Khadi Udyog",
            description: "Jetpur is famous for its khadi (handwoven cloth), and Vishal Khadi Udyog is one of the key places to learn about the process of khadi production. Visitors can explore how khadi is made and purchase high-quality, handcrafted khadi garments.",
            location: "Jetpur, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Throughout the year",
            activities: [
                "Learn the process of khadi weaving",
                "Purchase handwoven khadi products",
                "Engage with local artisans and weavers",
                "Understand the cultural significance of khadi",
                "Support sustainable and ethical fashion"
            ],
            mapLink: "https://maps.app.goo.gl/Z8tVym5nCj7tP2Ex9",
        },
    ]
};
